/* eslint-disable import/no-unresolved */
import { Component } from 'preact'
import { Link } from 'preact-router/match'
import { connect } from 'react-redux'
import classnames from 'classnames'

import styles from 'components/styles/main-menu.css'
import defaultLogoExtended from 'img/main-menu-logo-extended.png'
import defaultLogo from 'img/main-menu-logo.png'
import {
  getAllowYouTube,
  getMainMenuItems,
  isLoggedIn,
  selectCheckoutModuleEnabled,
  selectForceLogin,
} from 'selectors/app'
import sidebarItems from './items.enum'
import itemPath from './item-path'
import { MenuList, Hamburger } from './'

class SidebarMenu extends Component {
  state = {
    isMainMenuOpen: false,
    isSmallView: window.innerWidth <= 600,
    items: [],
  }

  componentDidMount() {
    const { items = [] } = this.props

    window.addEventListener('resize', this.resizePage)
    this.setState({
      //items: this.filterItems(items.length ? items : sidebarItems),
      items: this.filterItems(items),
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.setState({
        items: this.filterItems(this.props.items),
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizePage)
  }

  resizePage = () => {
    this.setState({
      isSmallView: window.innerWidth <= 600,
    })
  }

  openMainMenu = () => {
    if (this.state.isSmallView) {
      return null
    }

    this.setState({
      isMainMenuOpen: true,
    })
  }

  closeMainMenu = () => {
    if (this.state.isSmallView) {
      return null
    }

    this.setState({
      isMainMenuOpen: false,
    })
  }

  close = () => {
    this.setState({
      isMainMenuOpen: false,
    })
  }

  filterItems = items => {
    const knownTargets = [
      'home',
      'guide',
      'channel',
      'dvr',
      'video_library',
      'search',
      'settings',
      'support',
      'video_library_category',
      'external_url',
      'external_url_iframe',
    ]
    if (this.props.isLoggedIn) {
      knownTargets.push('account')
    } else {
      knownTargets.push('login')
    }
    if (this.props.checkoutModule) {
      knownTargets.push('checkout')
    }
    if (this.props.allowYouTube) {
      knownTargets.push('youtube')
    }
    return items.filter(item => knownTargets.indexOf(item.actionTarget) !== -1)
  }

  onItemClick = pos => () => {
    if (this.props.forceLogin && !this.props.isLoggedIn) {
      this.close()
      return
    }
    this.close()

    const item = this.state.items[pos]
    itemPath(item)
  }

  toggleHamburgerMenu = () => {
    this.setState({
      isMainMenuOpen: !this.state.isMainMenuOpen,
    })
  }

  render() {
    const { isMainMenuOpen, isSmallView, items } = this.state
    const logo = typeof window.TKL_LOGO !== 'undefined' ? window.TKL_LOGO : defaultLogo
    const logoExtended =
      typeof window.TKL_LOGO_EXTENDED !== 'undefined'
        ? window.TKL_LOGO_EXTENDED
        : defaultLogoExtended

    if (items) {
      return (
        <div
          onMouseEnter={this.openMainMenu}
          onMouseLeave={this.closeMainMenu}
          className={classnames(styles.mainMenu, {
            [styles.mainMenuOpen]: isMainMenuOpen && !isSmallView,
            [styles.mainMenuOpenPhone]: isMainMenuOpen && isSmallView,
          })}
        >
          <div className={styles.mainMenuComponent}>
            <div className={styles.mainMenuLogo}>
              <Link href="/">
                <img src={isMainMenuOpen && !isSmallView ? logoExtended : logo} />
              </Link>
            </div>
            <MenuList
              items={items}
              isMainMenuOpen={isMainMenuOpen}
              onClick={this.onItemClick}
            />
            <Hamburger
              isMainMenuOpen={isMainMenuOpen}
              onClick={this.toggleHamburgerMenu}
            />
          </div>

          <div
            className={classnames(styles.mainMenuItems, {
              [styles.visible]: isMainMenuOpen,
            })}
          >
            <MenuList
              items={items}
              isMainMenuOpen={isMainMenuOpen}
              onClick={this.onItemClick}
            />
          </div>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  items: getMainMenuItems(state),
  isLoggedIn: isLoggedIn(state),
  allowYouTube: getAllowYouTube(state),
  checkoutModule: selectCheckoutModuleEnabled(state),
  forceLogin: selectForceLogin(state),
})

export default connect(mapStateToProps)(SidebarMenu)
